export const DEFAULT_WELCOME_PAGE_CONFIG = { disable_metrics: false };
